import type { FaireProductEntity } from "../../entity_types/product";

export const p_ygqpn33gdu: FaireProductEntity = {
  token: "p_ygqpn33gdu",
  type: "product",
  name: "18K NON-TARNISH WATERPROOF STAINLESS STEEL BANGLE | 40B5153",
  brandToken: "b_9j5az29aau",
  brandName: "JOSSLYN by wall to wall",
  imageUrl: "https://cdn.faire.com/fastly/aeaa074ad4e78e12d527bb36eeb998c9769e1e6e4ea1ae05f5c4a0046e8e2758.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4d7c2b418f5d8898593fb6e401f483262cf3fe0dc4e452220e02348afbc08f8f.jpeg",
    "https://cdn.faire.com/fastly/94408a650706ca28bc99a82dc6864ce0515c14cb156b77efa81b62e0378d48d0.jpeg",
    "https://cdn.faire.com/fastly/b91d5ecfee2055264befaf61e7a4dfb0dacf6f06a106f8bc999bd2382698aea9.jpeg"
  ],
  priceDollars: 5.47,
  description: "The 18K Non-Tarnish Waterproof Stainless Steel Real Gold Dipped Rhinestone Stations Bangle is durability. Crafted from high-quality stainless steel with a real 18K gold dip, this bangle features elegantly placed rhinestone stations that add a subtle sparkle. Designed to be waterproof and tarnish-resistant. \n\nProduct Details:\ndiameter: 60mm\nclasp: Hinge\nMetal finish: Stainless Steel 18K Gold, Silver\nproduct: Lead & Nickel Compliant\nanti-tarnish:  Tarnish Free, Non-Tarnish\n\nReal Gold Dipped Bracelet\nStainless Steel Bracelet\nHypoallergenic Bracelet\nTarnish-Free Bracelet\nNon-Tarnish Bracelet\nWater Proof Bracelet\nWater Resistant Bracelet\nSweatproof Jewelry\nFade Resistant Bracelet\nAnti-oxidation \nPVD Coating",
  tags: [],
  msrpDollars: 10.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:08.405Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
